import React from "react";
import { Box, Grid, Stack } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";
import Spinner from "@atlaskit/spinner";
import Header from "./components/sections/Header";
import Main from "./components/sections/Main";
import { BannerContext } from "./context";

function Banner({
  isOnJSM,
  isLoading,
  config,
  globalConfig = {},
  cart,
  useNoBackgroundStyling = true,
}) {
  const backgroundStyles = useNoBackgroundStyling
    ? {}
    : {
        backgroundColor: token("color.background.disabled"),
        border: `1px solid ${token("color.border")}`,
      };

  if (isLoading)
    return (
      <Grid alignContent="center" justifyContent="center">
        <Spinner />
      </Grid>
    );

  return (
    <BannerContext.Provider
      value={{
        config,
        globalConfig,
        isOnJSM,
        totalPrice: cart?.totalPrice || 0,
        itemsInCart: cart?.items || [],
      }}
    >
      <Box
        padding={isOnJSM ? "space.0" : "space.300"}
        style={{
          width: "100%",
          borderRadius: "3px",
          marginTop: isOnJSM ? "24px" : "0px",
          ...backgroundStyles,
        }}
      >
        <Stack space="space.300">
          <Header />

          <Main />
        </Stack>
      </Box>
    </BannerContext.Provider>
  );
}

export default Banner;
